export default function FooterInternal() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer-internal"
      className="border-t border-border py-4 px-6 text-center text-xs text-muted-foreground"
    >
      <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-4">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
          <a
            href="/documents/termo-de-uso.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Termos de uso
          </a>
          <a
            href="/documents/politica-de-privacidade-de-dados.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Politica de privacidade
          </a>
          <a
            href="https://forms.gle/MeWEFigNcuPajfNf7"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Canal LGPD
          </a>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfVkY4UDixIbaDopdiIZzoCH91qZFjX0jdh9uH-vZ2EELraxg/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Canal de denuncias
          </a>
        </div>
        <span>LIQI | {year} — Todos os direitos reservados</span>
      </div>
    </footer>
  );
}
